/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import * as Yup from 'yup';
import { useSnackbar } from 'notistack5';
import { useCallback, useEffect, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import fileFill from '@iconify/icons-eva/file-fill';
import closeFill from '@iconify/icons-eva/close-fill';
import PropTypes from 'prop-types';
import axios from 'axios';
// material
import { LoadingButton } from '@material-ui/lab';
import { styled } from '@material-ui/core/styles';
import {
  Card,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  Autocomplete,
  FormHelperText,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TableContainer,
  TableBody,
  TableRow,
  Table,
  TableCell
} from '@material-ui/core';

import { AnimatePresence, motion } from 'framer-motion';
// eslint-disable-next-line import/no-unresolved
import { varFadeInRight } from 'src/components/animate';
// eslint-disable-next-line import/no-unresolved
import {
  createMasterFileData,
  resetMasterFileError,
  resetCreateFileStatus,
  updateMasterFile,
  getMasterFileData
  // eslint-disable-next-line import/no-unresolved
} from 'src/redux/slices/masterfile';
// eslint-disable-next-line import/no-unresolved
import { getCategoryListByProject, resetCategoryListByProject } from 'src/redux/slices/filecategory';
// eslint-disable-next-line import/no-unresolved
import { Icon } from '@iconify/react';
import * as XLSX from 'xlsx';
import { getProjectListByClient, resetProjectListByClient } from 'src/redux/slices/client';
import { MIconButton } from '../../@material-extend';
// eslint-disable-next-line import/named
import { UploadSingleFile } from '../../upload';
//
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import FilePreview from '../../common-components/FilePreview';
// ----------------------------------------------------------------------
import { useDispatch, useSelector } from '../../../redux/store';
import { fData } from '../../../utils/formatNumber';

const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1)
}));

// ----------------------------------------------------------------------
// File Preview UI component
const previewTable = ({ Data }) => (
  <TableContainer sx={{ minWidth: 800, overflow: 'scroll', height: 450 }}>
    <Table stickyHeader sx={{ border: 1 }}>
      <TableBody>
        {Data.map((Dataa, index) => (
          <TableRow sx={{ bgcolor: index % 2 === 0 ? '#3cb37117' : 'white', border: 1 }} key={index}>
            {Dataa.map((temp, tempIndex) => (
              <TableCell sx={{ border: 1 }} key={tempIndex}>
                {temp}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

FileManagementUpload.propTypes = {
  editId: PropTypes.number,
  setVisibleComponent: PropTypes.func,
  currentMasterFile: PropTypes.object
};

export default function FileManagementUpload({ currentMasterFile = {}, setVisibleComponent, editId }) {
  const { clientList, checkProjectLinked, projectListByClient } = useSelector((state) => state.client);
  const { categoryListByProject, checkCategoryLinked } = useSelector((state) => state.filecategory);
  const { error, createFileStatus, isLoading } = useSelector((state) => state.filemanager);
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [xlsTableData, setXlsTableData] = useState([]);
  const [preview, setPreview] = useState('');
  const [fileSize, setFileSize] = useState('');

  const dispatch = useDispatch();

  const handleOpenPreview = () => {
    setOpen(true);
  };

  const handleClosePreview = () => {
    setOpen(false);
  };

  const NewBlogSchema = Yup.object().shape({
    fileName: Yup.string().required('File Name is required'),
    fileCategory: Yup.mixed().required('File Type is required'),
    client: Yup.mixed().required('Client is required'),
    project: Yup.mixed().required('Project is required'),
    cover: editId ? '' : Yup.mixed().required('File is required')
  });

  const formik = useFormik({
    initialValues: {
      client: editId ? currentMasterFile.client : null,
      project: editId ? currentMasterFile?.project : null,
      fileName: editId ? currentMasterFile?.file_name : '',
      fileCategory: editId ? currentMasterFile?.category : null,
      cover: null
    },
    validationSchema: NewBlogSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const formData = new FormData();
        if (editId) {
          formData.append('file_name', values.fileName || '');
          formData.append('category', values.fileCategory.id || '');
          formData.append('client', values.client.id || '');
          formData.append('project', values.project.id || '');
        } else {
          formData.append('file_name', values.fileName || '');
          formData.append('category', values.fileCategory.id || '');
          formData.append('client', values.client.id || '');
          formData.append('project', values.project.id || '');
          formData.append('master_file', values.cover || null);
        }

        if (editId) {
          dispatch(updateMasterFile(formData, editId));
          dispatch(getMasterFileData());
        } else {
          dispatch(createMasterFileData(formData));
        }
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setSubmitting(false);
      }
    }
  });

  useEffect(() => {
    let masterFile;
    if (editId) {
      axios({
        url: currentMasterFile?.master_file,
        method: 'GET',
        responseType: 'blob'
      }).then((blob) => {
        masterFile = new File(
          [blob.data],
          currentMasterFile?.master_file?.substring(currentMasterFile?.master_file.lastIndexOf('/') + 1),
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );
        setFileSize(fData(masterFile?.size));
        handleXlsFilePreview(masterFile);
      });
    }
  }, [editId]);

  useEffect(() => {
    if (error || createFileStatus) {
      enqueueSnackbar(
        (createFileStatus && (!editId ? 'New File Uploaded Successfully' : 'File Updated Successfully')) ||
          (error && error),
        { variant: error ? 'error' : 'success' }
      );
      dispatch(getMasterFileData());
      dispatch(resetMasterFileError());
    }
    if (createFileStatus) {
      setVisibleComponent('List');
      formik.resetForm();
      // dispatch(getMasterFileData());
      dispatch(resetCreateFileStatus());
    }
  }, [error, createFileStatus]);

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;

  // File Uploading
  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (currentMasterFile.master_file === null) setPreview(file.path);
      if (file) {
        if (!editId) setPreview(file.path);
        handleXlsFilePreview(file);
        setFileSize(fData(file?.size));
        setFieldValue('cover', file);
      }
    },
    [setFieldValue]
  );

  // Xls file Preview Function ---
  const handleXlsFilePreview = async (file) => {
    const data = await file.arrayBuffer();
    const workBook = XLSX.read(data);
    const workSheets = workBook.Sheets[workBook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(workSheets, {
      header: 1,
      defval: ''
    });
    setXlsTableData(jsonData);
  };

  return (
    <>
      <FormikProvider value={formik}>
        <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Card sx={{ p: 3 }}>
                <Stack spacing={3}>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                    <Autocomplete
                      name="client"
                      fullWidth
                      value={values.client ? values.client : null}
                      options={clientList}
                      onChange={(e, value) => {
                        setFieldValue('project', '');
                        setFieldValue('fileCategory', '');
                        setFieldValue('client', value);
                        dispatch(resetCategoryListByProject());
                        if (value) {
                          dispatch(getProjectListByClient(value.id));
                        } else {
                          dispatch(resetProjectListByClient());
                        }
                      }}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      getOptionLabel={(option) => (option ? option?.client_name : '')}
                      renderInput={(params) => (
                        <TextField
                          error={Boolean(
                            (touched.client && errors.client) || checkProjectLinked || checkCategoryLinked
                          )}
                          helperText={(touched.client && errors.client) || checkProjectLinked}
                          required
                          {...params}
                          label="For Client"
                          margin="none"
                        />
                      )}
                    />

                    <Autocomplete
                      fullWidth
                      name="project"
                      value={values.project ? values.project : null}
                      options={projectListByClient}
                      onChange={(e, value) => {
                        setFieldValue('fileCategory', '');
                        setFieldValue('project', value);
                        if (value) {
                          dispatch(getCategoryListByProject(value.id));
                        } else {
                          dispatch(resetCategoryListByProject());
                        }
                      }}
                      getOptionLabel={(option) => (option ? option?.project_name : '')}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      renderInput={(params) => (
                        <TextField
                          error={Boolean((touched.project && errors.project) || checkCategoryLinked)}
                          helperText={(touched.project && errors.project) || checkCategoryLinked}
                          required
                          {...params}
                          label="For Project"
                          margin="none"
                        />
                      )}
                    />
                  </Stack>

                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ mt: 3 }}>
                    <TextField
                      fullWidth
                      label="File Name"
                      required
                      {...getFieldProps('fileName')}
                      error={Boolean(touched.fileName && errors.fileName)}
                      helperText={touched.fileName && errors.fileName}
                    />
                    <Autocomplete
                      fullWidth
                      name="fileCategory"
                      value={values.fileCategory ? values.fileCategory : null}
                      options={categoryListByProject}
                      onChange={(e, value) => setFieldValue('fileCategory', value)}
                      getOptionLabel={(option) => (option ? option?.category_name : '')}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      renderInput={(params) => (
                        <TextField
                          error={Boolean(touched.fileCategory && errors.fileCategory)}
                          helperText={touched.fileCategory && errors.fileCategory}
                          required
                          {...params}
                          label="File Type"
                          margin="none"
                        />
                      )}
                    />
                  </Stack>

                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 3, sm: 2 }}
                    justifyContent="space-evenly"
                    alignItems="center"
                  >
                    <div>
                      {editId && (currentMasterFile?.master_file === null || currentMasterFile?.master_file === '') ? (
                        <LabelStyle>No Master File*</LabelStyle>
                      ) : (
                        <LabelStyle>Master File*</LabelStyle>
                      )}

                      {!editId && (
                        <UploadSingleFile
                          showPreview={false}
                          maxSize={2000000}
                          accept=".xlsx"
                          file={values.cover}
                          onDrop={handleDrop}
                          error={Boolean(touched.cover && errors.cover)}
                        />
                      )}
                      {!editId && touched.cover && errors.cover && (
                        <FormHelperText error sx={{ px: 2 }}>
                          {touched.cover && errors.cover}
                        </FormHelperText>
                      )}
                    </div>
                  </Stack>

                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 3, sm: 2 }}
                    justifyContent="space-evenly"
                    alignItems="center"
                  >
                    {editId && currentMasterFile?.master_file && (
                      <List disablePadding>
                        <AnimatePresence>
                          <ListItem
                            component={motion.div}
                            {...varFadeInRight}
                            sx={{
                              my: 1,
                              py: 0.75,
                              px: 2,
                              borderRadius: 1,
                              color: (theme) => `${theme.palette.primary.main}`,
                              border: (theme) => `solid 1px ${theme.palette.primary.main}`,
                              bgcolor: 'background.paper'
                            }}
                          >
                            <ListItemIcon>
                              <Icon icon={fileFill} color="inherit" width={28} height={28} />
                            </ListItemIcon>
                            <ListItemText
                              primary={currentMasterFile?.master_file ? currentMasterFile?.master_file : preview}
                              secondary={fileSize}
                              primaryTypographyProps={{ variant: 'subtitle2' }}
                              secondaryTypographyProps={{ variant: 'caption' }}
                            />
                          </ListItem>
                        </AnimatePresence>
                      </List>
                    )}
                    {values.cover !== null && (
                      <List disablePadding>
                        <AnimatePresence>
                          <ListItem
                            component={motion.div}
                            {...varFadeInRight}
                            sx={{
                              my: 1,
                              py: 0.75,
                              px: 2,
                              borderRadius: 1,
                              color: (theme) => `${theme.palette.primary.main}`,
                              border: (theme) => `solid 1px ${theme.palette.primary.main}`,
                              bgcolor: 'background.paper'
                            }}
                          >
                            <ListItemIcon>
                              <Icon icon={fileFill} color="inherit" width={28} height={28} />
                            </ListItemIcon>
                            <ListItemText
                              primary={preview}
                              secondary={fileSize}
                              primaryTypographyProps={{ variant: 'subtitle2' }}
                              secondaryTypographyProps={{ variant: 'caption' }}
                            />
                            <MIconButton onClick={() => setFieldValue('cover', null)} edge="end" size="small">
                              <Icon icon={closeFill} />
                            </MIconButton>
                          </ListItem>
                        </AnimatePresence>
                      </List>
                    )}
                  </Stack>

                  <Stack direction="row" justifyContent="flex-end" sx={{ mt: 3 }} md={6} xs={6}>
                    <Button
                      type="button"
                      color="inherit"
                      variant="outlined"
                      onClick={handleOpenPreview}
                      sx={{ mr: 1.5 }}
                    >
                      Preview
                    </Button>
                    <LoadingButton type="submit" variant="contained" loading={isLoading}>
                      Save
                    </LoadingButton>
                  </Stack>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </Form>
      </FormikProvider>

      <FilePreview
        formik={formik}
        openPreview={open}
        onClosePreview={handleClosePreview}
        CalledComponent={previewTable}
        showableContent={xlsTableData}
      />
    </>
  );
}
